import React, { useEffect } from "react";

import "./layout.css";

import Sidebar from "../sidebar/Sidebar";
import TopNav from "../topnav/TopNav";
import AppRoutes from "../Routes";
import Login from "../../pages/Login/Login";

import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import ThemeAction from "../../redux/actions/ThemeAction";
import Dashboard from "../../pages/Dashboard";
import useNetworkStatus from "../Network/useNetworkStatus";
import {  Grow, Snackbar } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function GrowTransition(props) {
  return <Grow {...props} />;
}


const Layout = () => {
  const themeReducer = useSelector((state) => state.ThemeReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    const themeClass = localStorage.getItem("themeMode", "theme-mode-light");

    const colorClass = localStorage.getItem("colorMode", "theme-mode-light");

    dispatch(ThemeAction.setMode(themeClass));

    dispatch(ThemeAction.setColor(colorClass));
  }, [dispatch]);

  const { isOnline } = useNetworkStatus();
  const [open, setOpen] = React.useState(false);
  const [msgData, setMsgData] = React.useState({
    msg: "",
    type: "",
  });
  useEffect(() => {
    if (!isOnline) {
      setOpen(true);
      setMsgData({
        msg: "Internet not available, please check your network",
        type: "error",
      });
    } //alert("Internet not available, please check your network")
    // else alert('Internet not available')

    window.ononline = (event) => {
      setOpen(true);
      setMsgData({
        msg: "Internet connection restored",
        type: "success",
      });
    };
    window.onoffline = (event) => {
      setOpen(true);
      setMsgData({
        msg: "Internet connection dropped",
        type: "error",
      });
    };
  }, [isOnline]);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <div className={`layout ${themeReducer.mode} ${themeReducer.color}`}>
        <Sidebar />
        <div className="layout__content">
          <Snackbar open={open} autoHideDuration={16000} onClose={handleClose}
          TransitionComponent={GrowTransition}
          >
            <Alert
              onClose={handleClose}
              severity={msgData.type ==="success" ? 'success' : 'error'}
              sx={{ width: "100%" }}
            >
             {
              msgData.msg
             }
            </Alert>
          </Snackbar>
          <TopNav />
          <div className="layout__content-main">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
